import close from "assets/svgs/ic_close.svg";
import React from "react";
import Button from "../Button";
import { Dialog, DialogContent } from "../Dialog";
import { DialogProps } from "./types";

export default function Modal({
  onClose,
  title = "Title",
  children,
  contentClassName = "",
  modalClassName = "",
  onSubmit,
  submitText = "Archive",
  renderModalHeader,
  renderModalFooter,
  footerRender = true,
  isFullModel = false,
  width = "w-[500px]",
  height = "h-[auto]",
  optionalFooterClass = "",
  isSubmitDisabled,
  insetClassName,
  submitLoading,
  cancelButtonText = "Cancel",
  showCancelButton = true,
  showSubmitButton = true,
}: DialogProps) {
  return (
    <Dialog open={true} onOpenChange={onClose}>
      {/* for making backside of modal darker */}
      <div className={`fixed inset-0 bg-[#0000004D] z-50 ${insetClassName}`} />
      <DialogContent
        width={width}
        height={height}
        className={`!p-0 border-none shadow-lg bg-white rounded-lg overflow-hidden ${modalClassName}`}
      >
        <div className={isFullModel ? "flex flex-col" : ""}>
          {/* Header */}
          {renderModalHeader ? (
            renderModalHeader
          ) : (
            <div className="flex justify-between items-center bg-[#F4F5F7] border-b border-[#E9ECF2] px-6 py-4">
              <h3 className="text-lg font-medium text-[#253858]">{title}</h3>
              <button
                onClick={onClose}
                className="p-1 focus:outline-none outline-none disabled:cursor-not-allowed"
                disabled={submitLoading}
              >
                <img src={close} alt="close" className="w-6 h-6" />
              </button>
            </div>
          )}

          {/* Content */}
          <div
            className={`flex-grow p-4 overflow-y-auto ${contentClassName}`}
            style={{ maxHeight: "78vh" }}
          >
            {children}
          </div>
        </div>
        {/* Footer */}
        {footerRender && (
          <div
            className={
              optionalFooterClass.length
                ? optionalFooterClass
                : "flex justify-end items-center gap-4 bg-[#F4F5F7] border-t border-[#E9ECF2] px-6 py-4"
            }
          >
            {renderModalFooter ? (
              renderModalFooter
            ) : (
              <>
                {showCancelButton ? (
                  <button
                    onClick={onClose}
                    type="button"
                    className="bg-[transparent] text-secondary border border-secondary rounded-[4px] w-[106px] h-[36px] text-sm leading-[21px] font-normal text-center disabled:bg-gray-300 disabled:cursor-not-allowed"
                    disabled={submitLoading}
                  >
                    {cancelButtonText}
                  </button>
                ) : null}

                {showSubmitButton ? (
                  <Button
                    disabled={isSubmitDisabled}
                    onClick={onSubmit}
                    isLoading={submitLoading}
                    className={`${
                      isSubmitDisabled ? "bg-gray-300" : "bg-primary"
                    } text-white rounded-[4px] min-w-[106px] h-[36px] text-sm leading-[21px] font-normal text-center`}
                  >
                    {submitText}
                  </Button>
                ) : null}
              </>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
